import clinic1 from "../assets/images/clinic1.png";
import clinic2 from "../assets/images/clinic2.png";
import multi1 from "../assets/images/multi1.png";
import multi2 from "../assets/images/multi2.png";
import hospitalNetwork1 from "../assets/images/hospitalNetwork1.png";
import hospitalNetwork2 from "../assets/images/hospitalNetwork2.png";

const planData = {
  clinic: {

    title: "Clinic",
    subtitle: "For single-location practices",
    topImage: clinic1,

    introHeading: "Clinic Plan – Designed for Single-Location Practices",
    introText:
      "The Clinic Plan is best suited for independent healthcare practices looking for a robust digital system. It simplifies appointment workflows, prescription handling, lab reports, and administrative tasks—all in one platform.",

    coreFeatures: [
      {
        title: "1. Appointment Management",
        list: [
          "Online + walk-in appointment booking",
          "Automated confirmations & reminders",
          "Daily/Weekly/Monthly calendar view",
          "Doctor-wise scheduling",
          "Smart rescheduling system",
        ],
      },
      {
        title: "2. e-Prescriptions (e-Rx)",
        list: [
          "Create error-free prescriptions",
          "Medicine database with auto-suggestions",
          "Print/Share prescription instantly",
          "Secure cloud storage",
        ],
      },
      {
        title: "3. Basic Lab Workflows",
        list: [
          "Create lab orders for consultations",
          "Track sample status",
          "Upload & share lab reports",
          "Lab-wise doctor coordination",
        ],
      },
    ],

    whyChoose: {
      title: "Why Choose the Clinic Plan?",
      content:
        "The Clinic Plan offers an integrated approach to managing patient visits, medical records, and administrative workflows. It reduces manual work, improves patient experience, and provides easy-to-use tools for independent clinics.",
      image: clinic2,
    },
  },

  multiclinic: {
    title: "Multi-Clinic",
    subtitle: "For Growing Groups with Multiple Locations",
    topImage: multi1,

    introHeading: "Multi-Clinic Plan – Designed for Growing Healthcare Groups",
    introText:
      "The Multi-Clinic Plan is ideal for expanding healthcare groups with multiple branches. It provides centralized management while allowing branch-level autonomy. Synchronize patient records across locations, manage unified billing, and maintain consistent quality across all branches.",

    coreFeatures: [
      {
        title: "1. Multi-Location Management",
        list: [
          "Manage multiple clinic branches",
          "Centralized patient database",
          "Cross-location patient history",
          "Branch-wise performance tracking",
          "Unified reporting dashboard",
        ],
      },
      {
        title: "2. Centralized Administration",
        list: [
          "Master admin control panel",
          "Branch-level permissions",
          "Unified billing & invoicing",
          "Centralized staff management",
          "Resource allocation across branches",
        ],
      },
      {
        title: "3. Enhanced Coordination",
        list: [
          "Inter-branch referrals",
          "Shared specialist directory",
          "Unified prescription database",
          "Lab coordination across branches",
          "Integrated communication system",
        ],
      },
    ],

    whyChoose: {
      title: "Why Choose the Multi-Clinic Plan?",
      content:
        "Scale your healthcare business efficiently with seamless synchronization across all branches. Maintain consistent patient care standards while reducing administrative overhead. Get actionable insights with unified analytics and reporting.",
      image: multi2,
    },
  },

  network: {
    title: "Hospital Network",
    subtitle: "For Large Hospital Organizations",
    topImage: hospitalNetwork1,

    introHeading: "Hospital Network Plan – Enterprise-Level Healthcare Management",
    introText:
      "The Hospital Network Plan is the ultimate solution for large hospital groups and healthcare networks. It provides enterprise-grade infrastructure for managing complex operations including multiple departments, OT management, emergency services, insurance, and advanced patient care coordination.",

    coreFeatures: [
      {
        title: "1. Enterprise EMR & Patient Management",
        list: [
          "Comprehensive Electronic Medical Records",
          "Complete patient health history",
          "Advanced clinical documentation",
          "Integrated diagnostic tools",
          "Secure health information exchange",
        ],
      },
      {
        title: "2. Operational Management",
        list: [
          "OT (Operation Theater) scheduling",
          "IPD (In-Patient Department) management",
          "Emergency & critical care workflows",
          "Bed management & allocation",
          "Real-time occupancy tracking",
        ],
      },
      {
        title: "3. Insurance & Financial Integration",
        list: [
          "Multiple insurance provider integration",
          "TPA (Third-Party Administrator) support",
          "Automated claim processing",
          "Advanced billing & revenue cycle",
          "Financial analytics & reporting",
        ],
      },
    ],

    whyChoose: {
      title: "Why Choose the Hospital Network Plan?",
      content:
        "Built for enterprise-level complexity and scale. Manage large hospital networks with advanced analytics, automated workflows, and comprehensive reporting. Ensure regulatory compliance, optimize resource utilization, and deliver superior patient care across all departments and locations.",
      image: hospitalNetwork2,
    },
  },
};

export default planData;
